import { Icon, Intent, Popover, Position } from "@blueprintjs/core"
import { __ } from "../utilities"
import { Color } from "react-color"
import { useUser } from "src/settings/zustand/user"
import { IUser, useMainStore } from "src/settings/zustand"
import { showToast } from "./AppToaster" 

/* Protopia Ecosystem component */
export interface IRatingHandlerProps {
    rating?: any[]
    current:number
    max?: number
    size?: number
    color?: Color
    activeColor?: Color
    className?: string
    isActive: boolean
    onChange: (user: IUser, rating: number) => void
    isLoading?: boolean
}
const RatingHandler = (props: IRatingHandlerProps): JSX.Element => {
    const user = useUser()
    const mineRating = props.rating?.filter(r => r.user?.id === user.id )[0]?.rating  
    const onClick = (rating: number) => {
        if( !!user?.id ) {
            props.onChange(user, rating)
        }
        else {
            showToast({
                message: __("Action enabled only for logged user"),
                intent: Intent.DANGER,
                action: {
                    text: __("Log in"),
                    onClick: () => {
                        useMainStore.setState({ isOpenLogin: true })
                    }
                }
            })
            
        }
    }
    return <div>
        <div className={`pe-rating-handler-container d-flex align-items-center ${ props.className } ${ props.isLoading ? " opacity_5 " : "" }`} data-select-type="ignore">
            {
                Array(props.max || 5)
                    .fill( "1" )
                    .map(( __, i ) => {
                        const is: boolean = typeof mineRating === "undefined" ? false : i <= mineRating
                        return <Icon 
                            key={ i } 
                            icon={  is ? "star" : "star-empty" }
                            color={ is ? ( props.activeColor || "darkred" ).toString() : ( props.color || "red" ).toString() }
                            size={ props.size || 16 }
                            className={`mr-1 ${ props.isActive ? "pointer" : "pointer" } `}
                            onClick={ () => onClick( i ) }
                        />
                    })
            }
            
        </div>
        
            
                <div style={{ fontSize: props.size || 16, cursor: "pointer", marginTop: 7 }}>
                    <div className="small letter-spacing-1">
                        {__("Average rating")}: 
                        <span className="title ml-1">{ (!!props.rating?.length ? (props.rating?.reduce((sum, res) => sum + res.rating + 1, 0)) / props.rating?.length : 0).toFixed(1) }</span>
                        <span className="mx-1">|</span>
                        <Popover
                            position={ Position.TOP_LEFT }
                            interactionKind="hover"
                            content= {
                                <div className="p-2">
                                    {
                                        !!props.rating?.length 
                                            ?
                                            props.rating.map(( r, i ) => {
                                                return <div className="d-flex align-items-center" key={ r.user.id + i }>
                                                    <div className="avatar mr-2" style={{ backgroundImage: `url(${r.user.avatar})`, width: 15, height: 25 }} />
                                                    <div className="smaller letter-spacing-2">{r.user.display_name}</div>
                                                    <div className="small title ml-2">{ r.rating + 1 }</div>
                                                </div>
                                            })
                                            :
                                            __("No ratings")
                                    }
                                </div>

                            }
                        >
                            <span>{ props.rating?.length || 0}</span>
                        </Popover>
                    </div> 
                </div>
                
            
    </div>
}
export default RatingHandler